import {
    Autocomplete,
    FormControl,
    TextField,
    Tooltip,
} from "@mui/material";

import { useState } from "react";
import { extractDataGroup } from "utility/helper";

const frequencylabel = [
    {
        label: "5 Sec",
        value: "5"
    },
    {
        label: "10 Sec",
        value: "10"
    },
    {
        label: "15 Sec",
        value: "15"
    },
    {
        label: "20 Sec",
        value: "20"
    }
]

interface item {
    label: string,
    value: string,
}

const CdadHeaderSamplingFilterComponent = (props: any) => {
    const getSelectedValue = (frequency: string): item | null => {
        let selectedItem: item | null = null;
        frequencylabel?.forEach((item: any) => {
            if(item?.value === frequency) {
                selectedItem = item
            }
        })
        return selectedItem;
    }
    const [frequency, setFrequency] = useState<item | null>(getSelectedValue(extractDataGroup(props.unNestedParamData, "frequency")) || {label: "", value: ""});
    const handleChange = (e: any, selectedValue: any) => {
        setFrequency(selectedValue?.label)
        props.getUpdatedList({
            title: "frequency",
            value: selectedValue?.value,
        });
    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
            <div className="signalFilterList" style={{ padding: "8px" }}>
                <Tooltip title={frequency?.value ? frequency?.toString() : "Select Frequency"} placement="top">
                    <FormControl style={{ width: "210px", fontSize: "12px" }} required>
                        <Autocomplete
                            disablePortal
                            value={frequency}
                            options={frequencylabel}
                            sx={{ width: 300 }}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Frequency" />}
                            onChange={(e, value) => handleChange(e, value)}
                        />
                    </FormControl>
                </Tooltip>
            </div>
        </div>
    );
};

export default CdadHeaderSamplingFilterComponent;
